// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__BBK4I","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3XuUw"};